module.exports = __webpack_public_path__ + "img/upload-doc-mob.15d7ce77.svg";